import { InputFilter } from '@lifebit-ai/lds'
import React from 'react'

interface FileNameFilterProps {
  onApply: (searchTerm: string) => void
  onReset: () => void
}

export const FileNameFilter: React.FC<FileNameFilterProps> = ({ onApply, onReset }) => {
  return (
    <InputFilter
      label="Dataset / File"
      searchFieldPlaceholder="Search dataset or file name"
      onApply={onApply}
      onReset={onReset}
    />
  )
}
